import { Link } from "react-router-dom";
import { Users, ChevronRight } from "lucide-react";

export function TeamLink({ testId }) {
  return (
    <Link
      to="/equipe"
      data-testid={testId}
      className="flex items-center gap-3 rounded-2xl bg-white border-2 border-slate-200 hover:border-orange-500 p-4 transition-colors"
    >
      <span className="w-12 h-12 rounded-xl bg-orange-500 text-slate-900 grid place-items-center">
        <Users className="w-6 h-6" />
      </span>
      <span className="flex-1">
        <span className="block font-display text-xl font-bold uppercase">Défi entre collègues</span>
        <span className="block text-sm text-slate-600">Classement de l'équipe</span>
      </span>
      <ChevronRight className="w-5 h-5 text-slate-400" />
    </Link>
  );
}
